import { StaffType } from 'types/staff'
import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { fetchStaffsAction } from 'reducks/staff/actions'
import { fetchEventRefs, replaceStaffInList } from 'reducks/staff/operations'
import { UPDATE_STAFF_STORES_ENDPOINT } from 'constants/urls'
import { fetchStaff, postStaffApi, toStaffApiErrorMessage } from 'repos/staff'

// メンバーの権限変更。scopeStoreRefs（権限変更画面に表示した、操作者が管理している店舗）の権限とメール受信設定だけを変え、
// 他店舗の分は保持する。sacri station の権限の制限とメール受信設定の作成は Functions 側で行う
const saveStaff = (
  staff: StaffType,
  role: number,
  storeRefs: FirebaseDocRefType[],
  scopeStoreRefs: FirebaseDocRefType[]
) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(showLoadingAction())
    try {
      await postStaffApi(UPDATE_STAFF_STORES_ENDPOINT, {
        staff_uid: staff.uid,
        role,
        store_ids: storeRefs.map((storeRef) => storeRef.id),
        scope_store_ids: scopeStoreRefs.map((storeRef) => storeRef.id),
      })
      const [nextStaff, eventRefs] = await Promise.all([fetchStaff(staff.uid), fetchEventRefs()])
      const { staff: staffState, auth } = getState()
      dispatch(
        fetchStaffsAction(
          replaceStaffInList(staffState.staffs, staff.uid, nextStaff, auth.switching_store_refs, eventRefs)
        )
      )
    } catch (error) {
      console.error(error)
      alert(toStaffApiErrorMessage(error, 'メンバーの権限の変更に失敗しました。'))
    } finally {
      dispatch(hideLoadingAction())
    }
  }
}

export default saveStaff
